module.exports = __webpack_public_path__ + "img/back.b801ca3e.svg";